import { Injectable } from "@angular/core";
import { BaseApiClientCustomFieldsV2Service } from "src/app/api/base-api-client-custom-fields-v2.service";
import { HttpClientHelperService } from "src/app/api/http-client-helper.service";

/**
 * Collaborator-facing custom-fields v2 reads.
 *
 * The portal endpoint (`v2/custom-fields`) only authenticates the PortalAuth/AiAgentAuth schemes,
 * so a collaborator's CollaborationAuth token gets a 401 there (mine#backend PR 41685). Backend
 * added a dedicated read-only collaboration controller at `custom-fields/v2/collaboration`
 * (GET list + GET /{id}, PortalCollaborator policy) instead of widening the portal endpoint's auth.
 * This override points the unified custom-fields v2 client at that route when running inside the
 * collaboration app, mirroring ApiClientCollaborationCompanySettingsService for the v1 fields/values.
 *
 * Only reads are supported server-side for collaborators - create/update/delete are intentionally
 * left inherited (unused in the collaboration app) rather than pointed at a non-existent route.
 */
@Injectable({
  providedIn: 'root'
})
export class ApiClientCollaborationCustomFieldsV2Service extends BaseApiClientCustomFieldsV2Service {
  protected override readonly fieldsController: string = 'custom-fields/v2/collaboration';

  constructor(httpClientHelper: HttpClientHelperService) {
    super(httpClientHelper);
  }
}
